<!-- 非外部經紀人員或是外部經紀人員 -->
<div *ngIf="(is_login && user  && user.powers?.power_id != 16)">
  	<app-navbar [user]="user"   (change_status)="change_status($event)"></app-navbar>

  	<!-- $event 參數這樣寫, $字號不可拿掉  -->
  	<app-main-sidebar [user]="user"   (notify)="onNotify($event)"></app-main-sidebar>

  	<div class="content-wrapper">
  		<!--app-content [id]="id"></!--app-content-->
    	<router-outlet></router-outlet>
  	</div>

  	<app-ctrl-sidebar></app-ctrl-sidebar>
  	<app-footer></app-footer>
</div>

<!-- 外部經紀人員或是外部經紀人員pc版 -->
<div *ngIf="(is_login && user  && user.powers?.power_id == 16 && isDesktop == true)">
	<!-- <app-otnavbarpc [user]="user"   (change_status)="change_status($event)"></app-otnavbarpc> -->

	<!-- $event 參數這樣寫, $字號不可拿掉  -->
	<app-otmain-sidebarpc [user]="user"   (notify)="onNotify($event)"></app-otmain-sidebarpc>

	<div class="content-wrapper">
		<!--app-content [id]="id"></!--app-content-->
	  <router-outlet></router-outlet>
	</div>

	<app-ctrl-sidebar></app-ctrl-sidebar>
	<app-footer></app-footer>
</div>

<!-- 外部經紀人員手機板 -->
<div *ngIf="is_login && user && user.powers.power_id == 16 && isDesktop == false">

  	<!-- <app-otnavbar [user]="user"   (change_status)="change_status($event)"></app-otnavbar> -->

  	<!-- $event 參數這樣寫, $字號不可拿掉  -->
	   
  	<app-otmain-sidebarmoblie [user]="user"   (notify)="onNotify($event)"></app-otmain-sidebarmoblie>

  	<div class="content-wrapper">
    	<router-outlet></router-outlet>
  	</div>
  	<app-footer></app-footer>

</div>

<div *ngIf="!is_login">
  	<app-signin [is_login]="is_login"  (change_status)="change_status($event)"></app-signin>
</div>


